import gql from 'graphql-tag';

const CAMPAIGN_ORDER_SESSIONS_CONNECTION = gql`
  query CampaignOrderSessionsWithEventsConnection(
    $first: Int
    $skip: Int
    $where: CampaignOrderSessionsWithEventsWhereInput
    $orderBy: CampaignOrderSessionsWithEventsOrderByInput
  ) {
    campaignOrderSessionsWithEventsesConnection(first: $first, skip: $skip, where: $where, orderBy: $orderBy) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          key
          sessionId
          start
          end
          durationInSeconds
          pageViews
          totalImpressions
          landingPage
          exitPage
          deviceType
          attrMethod
          attrValue
          attrWindow
        }
        cursor
      }
      aggregate {
        count
      }
    }
    full: campaignOrderSessionsWithEventsesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_SESSIONS_CONNECTION;
